var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _line3, _rect13, _rect14, _rect15, _rect16, _rect17, _line4, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionsSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 133,
    viewBox: "0 0 768 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 6.55671e-8,
    x2: 1.5,
    y2: 43,
    stroke: "white",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 40,
    height: 9,
    rx: 4.5,
    fill: "#DDE3EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 17,
    width: 40,
    height: 9,
    rx: 4.5,
    fill: "#DDE3EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 17,
    width: 80,
    height: 9,
    rx: 4.5,
    fill: "#DDE3EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 17,
    width: 80,
    height: 9,
    rx: 4.5,
    fill: "#DDE3EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 17,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#DDE3EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 1,
    transform: "translate(0 35)",
    fill: "#F1F3F5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 30,
    x2: 1.5,
    y2: 73,
    stroke: "white",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 47,
    width: 40,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 47,
    width: 59,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 47,
    width: 80,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 47,
    width: 208,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 47,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 1,
    transform: "translate(0 65)",
    fill: "#F1F3F5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 60,
    x2: 1.5,
    y2: 103,
    stroke: "white",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 77,
    width: 40,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 77,
    width: 40,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 77,
    width: 220,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 77,
    width: 80,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 77,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 90,
    x2: 1.5,
    y2: 133,
    stroke: "white",
    strokeWidth: 3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 107,
    width: 40,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 107,
    width: 40,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 107,
    width: 183,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 107,
    width: 137,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 107,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#F7F8F9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 1,
    transform: "translate(0 125)",
    fill: "#F1F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsSkeleton);
export default __webpack_public_path__ + "static/media/transactions-skeleton.0f5ee554fb0bd2b12405fae09b88d04c.svg";
export { ForwardRef as ReactComponent };